module.exports = __webpack_public_path__ + "img/right-dialog-item-bg.2d9c3f82.png";